import { render, staticRenderFns } from "./GideLayout.vue?vue&type=template&id=3d165c8d&scoped=true"
import script from "./GideLayout.vue?vue&type=script&lang=js"
export * from "./GideLayout.vue?vue&type=script&lang=js"
import style0 from "./GideLayout.vue?vue&type=style&index=0&id=3d165c8d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d165c8d",
  null
  
)

export default component.exports